import React, { useEffect, useState } from 'react';
import { ACTIVITY_LOG_STATUS, EVENT_REGISTRATION_NAME, EVENT_TYPE_AGENT_VALUE, TMX_FAILURE, EVENT_FULL_STEP_UP_NAME,
    EVENT_PHONE_BASED_ID_CONFIRMATION
 } from '../../shared/Constants';
import Input from '../../UI/Input/Input';
import { checkStartEndDatesBeyondGivenMonths, checkValidity, compareDates } from "../../shared/utility";

const StatusStartEndDate = (props) => {

    function formatDate() {
        const date = new Date()
        date.setMonth(date.getMonth() - 6)
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();
    
        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;
    
        return [year, month, day].join('-');
    }

    const [formInputElements, setFormInputElements] = useState({
        eventStatus:{
            elementType: 'select',
                elementConfig: {
                    type: 'text',
                    id: 'eventStatus',
                    placeholder: '',
                    options: ACTIVITY_LOG_STATUS.map(
                        status => ({
                            "disabled": false,
                            "value": (status === 'NONE OF THE ABOVE')?'':status,
                            "displayValue": status
                        })
                    )
                },
                value: props.eventStatusValue,
                validation: {
                    required: false
                },
                valid: true,
                touched: false,
                label: "Status",
                inputType: "OneThird"
        },
        startDate:{
            elementType: 'input',
            elementConfig: {
                type: 'date',
                id: 'startDate',
                placeholder: '99-99-9999',
                min: formatDate(),
                max: '9999-12-31'
            },
            value: props.startDateValue,
            validation: {
                required: false,
                restrictFuture: true
            },
            valid: true,
            touched: false,
            label: "Start Date",
            inputType: "OneThird"
        },
        endDate:{
            elementType: 'input',
            elementConfig: {
                type: 'date',
                id: 'endDate',
                placeholder: '99-99-9999',
                min: formatDate(),
                max: '9999-12-31'
            },
            value: props.endDateValue,
            validation: {
                required: false,
                restrictFuture: true
            },
            valid: true,
            touched: false,
            label: "End Date",
            inputType: "OneThird"
        },
    })

    useEffect(() => {
        props.clearSearch.current = clearStatusStartEnd
    },[])

    useEffect(() => {
        props.clearSearch.current = clearStatusStartEnd
        const status_map = [...formInputElements.eventStatus.elementConfig.options];
        const new_form = {...formInputElements};
        if (((props.event === EVENT_REGISTRATION_NAME || props.event === EVENT_FULL_STEP_UP_NAME) && props.eventType !== EVENT_TYPE_AGENT_VALUE)
        ||
    (props.eventType === EVENT_TYPE_AGENT_VALUE && props.event===EVENT_PHONE_BASED_ID_CONFIRMATION)) {
            const existedValue = status_map.find( ({value}) => value === TMX_FAILURE);
            if(!existedValue){
                status_map.push({
                    "disabled": false,
                    "value": TMX_FAILURE,
                    "displayValue": TMX_FAILURE
                });
                new_form.eventStatus.elementConfig.options = status_map;
            }
        }else{
            new_form.eventStatus.elementConfig.options = status_map.filter(itm => itm.value !== TMX_FAILURE);
        }
        setFormInputElements(new_form);
    }, [props.event, props.eventType])

    const clearStatusStartEnd = () => {
        const updatedForm = {...formInputElements}

        updatedForm['eventStatus'].value = 'Select One'
        updatedForm['eventStatus'].touched = false
        updatedForm['eventStatus'].valid = true

        updatedForm['startDate'].value = ''
        updatedForm['startDate'].touched = false
        updatedForm['startDate'].valid = true

        updatedForm['endDate'].value = ''
        updatedForm['endDate'].touched = false
        updatedForm['endDate'].valid = true

        setFormInputElements(updatedForm)
        props.setFormIsValid(true)
    }

    const inputChangedHandler = (event, inputIdentifier) => {

        let updatedForm = {...formInputElements};

        const updatedFormElement = { ...updatedForm[inputIdentifier] };
        updatedFormElement.value = event.target.value;
        if(event.target.value) {
            const validation = checkValidity(updatedFormElement.value, updatedFormElement.validation);
            updatedFormElement.valid = validation.isValid;
            props.errorHandler({message: validation.message});
        } else {
            updatedFormElement.valid = true;
            props.errorHandler(null);
        }
        updatedFormElement.touched = true;
        updatedForm[inputIdentifier] = updatedFormElement;
        let formIsValid = true;
        for (let inputIdentifier in updatedForm) {
            formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
        }
        if(inputIdentifier === 'eventStatus'){
            props.setEventStatus(event.target.value)
        }else if(inputIdentifier === 'startDate'){
            props.setStartDate(event.target.value)
        }else{
            props.setEndDate(event.target.value)
        }
        if((inputIdentifier === 'startDate' || inputIdentifier === 'endDate')&&event.target.value !== ''){
            const dateBeyondGivenMonthsCheck = checkStartEndDatesBeyondGivenMonths(updatedFormElement.value, 6)
            if(!dateBeyondGivenMonthsCheck){
                props.errorHandler({"message":"Start/End Date cannot be older than six months from the current month."}) 
                formIsValid = false   
                updatedFormElement.valid = false
            }
        }
        if ((formInputElements.startDate.value && inputIdentifier === 'endDate') &&
        !compareDates(formInputElements.startDate.value, event.target.value) && event.target.value !== '') {
            props.errorHandler({"message":"Start Date cannot be greater than End Date."});
            formIsValid = false;
            updatedFormElement.valid = false;
        }else if ((formInputElements.endDate.value && inputIdentifier === 'startDate') &&
        !compareDates(event.target.value, formInputElements.endDate.value) && event.target.value !== '') {
            props.errorHandler({"message":"Start Date cannot be greater than End Date."}) 
            formIsValid = false   
            updatedFormElement.valid = false
        }
        props.setFormIsValid(formIsValid);
        setFormInputElements(updatedForm);
    }

    const createForm = () => {

        const formsElementsArray =[];

        for(let key in formInputElements) {
            formsElementsArray.push({
                id: key,
                config: formInputElements[key]
            });
        }

    
        return (
        <>
            <div style={{"display":"flex"}}>
                {formsElementsArray.map((formElement => (
                    <Input
                        key={formElement.id}
                        elementType={formElement.config.elementType}
                        elementConfig={formElement.config.elementConfig}
                        value={formElement.config.value}
                        invalid={!formElement.config.valid}
                        shouldValidate={formElement.config.validation}
                        touched={formElement.config.touched}
                        label={formElement.config.label}
                        changed={(event) => inputChangedHandler(event, formElement.id)}
                        extendedInput={formElement.config.extendedInput}
                        inputType={formElement.config.inputType}
                    />
                )))}
            </div>
        </>
        )
        
    }

    return <>
        {createForm()}
    </>

}

export default StatusStartEndDate;